import { FormFields } from "../../../../models/newSupportCall";
import SupportCallOccurrenceFields from "../SupportCallOccurrenceFields";
import TasAdditionalFields from "./TasAdditionalFields";

export interface ITasFormData {
    formData: FormFields;
    errors: Partial<Record<keyof FormFields, string>>;
    updateField: <K extends keyof FormFields>(field: K, value: FormFields[K]) => void;
    name: string;
    fetchVehicle: (chassis: string) => Promise<void>;
}

const TasForm = ({ formData, errors, updateField, name, fetchVehicle }: ITasFormData) => {
    return (
        <>
            <SupportCallOccurrenceFields
                formData={formData}
                errors={errors}
                updateField={updateField}
                name={name}
                fetchVehicle={fetchVehicle}
                subject={formData.subject ?? ''}
            />
            <TasAdditionalFields
                subject={formData.subject ?? ''}
                formData={formData}
                errors={errors}
                updateField={updateField}
            />
        </>
    );
};

export default TasForm;
